module.exports = __webpack_public_path__ + "static/media/clientsIcon.99ea7229.svg";